<template>
	<window-view title="Bruger" v-on="$listeners" style="width: 500px;" :actions="_actions">
		<panel-view v-show="tab == 'project'">
			<panel-sep-view>
				<grid-view>
					<input-view v-model="model.name" label="Navn" />
				</grid-view>
				<grid-view>
					<input-view v-model="model.username" label="Brugernavn" />
				</grid-view>
			</panel-sep-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="model.password" label="Adgangskode" type="password" />
				</grid-view>
			</panel-sep-view>
			<grid-view>
				<switch-view-2 label="Desktop" v-model="model.desktop" />
				<switch-view-2 label="Mobil" v-model="model.mobile" />
			</grid-view>
		</panel-view>

	</window-view>
</template>

<script>
	import { bus } from '../../bus'

	export default {
		props: {
			id: {
				type: Number,
				default: null
			}
		},
		data() {
			return {
				tab: 'project',

				countries: [],

				model: {
					id: null,
					name: '',
					username: '',
					password: '',
					desktop: false,
					mobile: false
				},
				languages: [
					{
						label: 'Dansk',
						value: 'da'
					},
					{
						label: 'English',
						value: 'en'
					}
				]
			};
		},
		computed: {
			_actions() {
				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return this.$attrs.submit(this.model);
						}
					}
				];
			},
			_tabs() {
				return [
					{
						label:	'Projekt',
						value:	'project'
					}
				];
			}
		},
		async created() {
			const model = (await Promise.resolve(this.$attrs.model)).data;

			if (model) {
				console.log('EDIT!!!', model);
				this.model = model;
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>